import { OpenAPI } from '../generated/core/OpenAPI'
import { getStorageValue } from '../utils'
import { ACCESS_TOKEN_KEY, API_ENDPOINT } from '../constants'

// Configure the generated OpenAPI client with authentication
// Set base URL
OpenAPI.BASE = API_ENDPOINT

// Configure custom headers to match existing API format (JWT instead of Bearer)
;(OpenAPI as any).HEADERS = () => {
  const storedToken = getStorageValue(ACCESS_TOKEN_KEY)
  if (!storedToken) {
    return {}
  }
  return {
    Authorization: storedToken,
  }
}

// Clear TOKEN since we're using HEADERS instead
OpenAPI.TOKEN = undefined

// Re-export all generated services and types with auth configured
export * from '../generated'
